import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SmsBlock } from 'ui/lexus/components';

import styles from './styles';

const {
    ModalContent,
    ModalTitle,
    ModalText,
    ModalTextContainer,
    Modal,
} = styles;

export class ModalCheckStatus extends Component {
    componentDidMount() {
        document.querySelector('body').classList.add('overflow');
    }

    componentWillUnmount() {
        document.querySelector('body').classList.remove('overflow');
    }

    render() {
        const {
            status: {
                data: {
                    order: {
                        firstName,
                        lastName,
                        phone = '',
                    } = {},
                },
                isLoaded,
            },
            showCheckStatus,
            handleClose,
        } = this.props;

        const N = phone.replace(/\D/g, '');
        const phoneFormatted = `+7 (***) ***-${N.substring(7, 9)}-${N.substring(9, 11)}`;

        return isLoaded && showCheckStatus ? (
            <Modal id="checkStatusModal">
                <ModalContent>
                    <ModalTitle>Проверка статуса платежа</ModalTitle>
                    <ModalTextContainer>
                        <ModalText>{firstName} {lastName},</ModalText>
                        <ModalText>
                                для просмотра статуса платежа
                                введите, пожалуйста, код из СМС,
                                который придет на номер телефона,
                                указанный ранее {phoneFormatted}
                        </ModalText>
                    </ModalTextContainer>
                    <SmsBlock handleClose={handleClose} />
                </ModalContent>
            </Modal>
        ) : null;
    }
}

export default connect(
    state => ({
        status: state.brand.status,
    }),
    null,
)(ModalCheckStatus);
